<template>
  <div>
    <UserEventSearch
      v-model="search"
      :list="listType"
      @input="submitSearch"
      @update:view="setListType($event)"
    />

    <b-alert :show="hasActiveOrganization === false" variant="danger"
      >Konto użytkownika nie jest przypisane do żadnej organizacji. Proszę
      uzupełnić dane w
      <router-link to="/user/account">profilu</router-link>.</b-alert
    >

    <UserEventResultsGrid v-if="listType == 'grid'" />
    <UserEventResultsTable v-if="listType == 'table'" />

    <b-pagination
      v-model="currentPage"
      :total-rows="total"
      :per-page="perPage"
      align="center"
      @input="getEvents($event)"
    ></b-pagination>
  </div>
</template>

<script>
import PublicEventList from "./PublicEventList";
import UserEventSearch from "./UserEventSearch";
import UserEventResultsTable from "./UserEventResultsTable";
import UserEventResultsGrid from "./UserEventResultsGrid";

export default {
  name: "UserEventList",
  components: {
    UserEventSearch,
    UserEventResultsTable,
    UserEventResultsGrid
  },
  extends: PublicEventList,
  data() {
    return {
      listType: "table"
    };
  },
  computed: {
    user() {
      return this.$store.state.User.user;
    },
    hasActiveOrganization() {
      return this.user.hasActiveOrganization();
    }
  }
};
</script>
